import { FunctionalComponent } from 'preact';
import cn from 'classnames';
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import SearchIcon from '@material-ui/icons/Search';
import { engineIcons } from '../../utils';

import styles from './styles.module.scss';
import { Engines } from '../../slice/types';

interface Props {
  isSubmitted: boolean;
  icon?: string;
  onClick?: (evt: MouseEvent) => unknown;
  engine: Engines
}

const SearchIconArea: FunctionalComponent<Props> = ({
                                                      isSubmitted,
                                                      icon,
                                                      onClick,
                                                      engine,
                                                    }: Props) => {
  const renderIcon = () => {
    if (isSubmitted) return (
      <div className={styles.submitSearch}>
        <CircularProgress size={22} />
      </div>
    );

    if (typeof window === 'undefined') {
      return <div className={styles.submitSearch} />
    }

    return icon ?
      <div className={styles.submitSearch}>
        <img src={icon} width={22} height={22} alt="" />
      </div> : (
        <button
          className={styles.submitSearch}
          type="button"
          onClick={onClick}
        >
            <span className={styles.searchIcon}>
              {engine ?
                <img src={engineIcons[engine]} className={styles.search} alt="" /> :
                <SearchIcon className={styles.search} />
              }
              {!!onClick && <ArrowDropDownIcon className={styles.arrow} />}
            </span>
        </button>
      );
  };

  return (
    <div className={cn(styles.submitSearchWrapper, !onClick && styles.isDisabled)}>
      {renderIcon()}
    </div>
  );
};

export default SearchIconArea;
